// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable max-classes-per-file */
export class FetchError extends Error {
  // @ts-expect-error: Flow to TS migration.
  status: number

  // @ts-expect-error: Flow to TS migration.
  statusText: string

  // @ts-expect-error: Flow to TS migration.
  data: string

  headerRequestId: string | null | undefined
}

export class AbortError extends Error {
  originalError: Error | null | undefined

  constructor(message: Error | string) {
    super()
    this.name = "AbortError"

    if (message instanceof Error) {
      this.originalError = message
      this.message = message.message
    } else {
      this.message = message
      this.originalError = new Error(message)
      this.originalError.stack = this.stack
    }
  }
}
